import React from 'react';

import { HelpIcon } from '@change/ds-icons';

import { Avatar, Text } from '@change/ds-core-ui/next';

import type { NormalizedDecisionMaker } from '../../../shared/types';
import { DecisionMakerResponse } from '../../shared/DecisionMakerResponse';
import { Name } from '../../shared/Name';
import { SignersText } from '../../shared/SignersText';

export const Member: React.FC<NormalizedDecisionMaker> = ({
	photoUrl,
	displayName,
	publiclyVisible,
	slug,
	id,
	title,
	signersText,
	response,
}) => {
	return (
		<div className="flex">
			<Avatar src={photoUrl || undefined} alt={displayName} size={32} className="mb-3 mr-3 flex-shrink-0" />
			<div className="flex flex-col md:items-start">
				<div className="mb-4">
					<div className="flex items-center">
						<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
						<HelpIcon size={15} className="text-icon-strong mr-1" />
					</div>

					<div>
						<Text variant="body" className="text-muted mb-2 mr-2 text-sm lg:mb-0">
							{title}
						</Text>

						{signersText && (
							<div className="hidden lg:block">
								<SignersText signersText={signersText} />
							</div>
						)}
					</div>
				</div>

				{response && <DecisionMakerResponse response={response} />}
			</div>
		</div>
	);
};
